import axios from 'axios'

// Endereço da API por ambiente: definido em REACT_APP_API_URL no docker-compose.yml
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8085';

axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
export const httpClient = axios.create({
    baseURL: API_URL,
    withCredentials: false
})

export const httpClient2 = axios.create({
  baseURL: API_URL,
  withCredentials: false,
  responseType: 'blob'
})

class ApiService {
  constructor(apiUrl) {
    this.apiUrl = apiUrl;
  }

  static registrarToken(token) {
    if(token) {
      httpClient.defaults.headers.common['Authorization'] = `Bearer ${token}`
      httpClient2.defaults.headers.common['Authorization'] = `Bearer ${token}`
    }
  }

  post(url, objeto) {
    const requestUrl = `${this.apiUrl}${url}`
    return httpClient.post(requestUrl, objeto);
  }

   post2(url, objeto) {
    const requestUrl = `${this.apiUrl}${url}`
    return httpClient2.post(requestUrl, objeto);
  }

  put(url, objeto) {
    const requestUrl = `${this.apiUrl}${url}`
    return httpClient.put(requestUrl,objeto);
  }

  delete(url) {
    const requestUrl = `${this.apiUrl}${url}`
    return httpClient.delete(requestUrl);
  }

  get(url) {
    const requestUrl = `${this.apiUrl}${url}`
    return httpClient.get(requestUrl);
  }

  get2(url) {
    const requestUrl = `${this.apiUrl}${url}`
    return httpClient2.get(requestUrl);
  }
}

export default ApiService